<template>
  <div :class="$style['subnav-panel']" ref="rootDom">
    <div :class="$style['panel-inner']">
      <div :class="$style['nav-list']">
        <a
            v-for="(item, index) in data"
            :key="index"
            :class="$style['nav-item']"
            @click="handleClick(item)"
        >
          <div :class="$style['item-inner']" class="flex">
            <div :class="$style['item-icon']">
              <i v-if="!item.iconType" :class="[$style['ic'], item.icon]"></i>
              <Exicon v-else :size="20" :name="item.icon"/>
            </div>
            <div :class="$style['item-content']">
              <div :class="$style['item-title']">{{ item.title }}</div>
              <div :class="$style['item-subtitle']">{{ item.subtitle }}</div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {useLighterBorder} from '../../plugins/use-lighter-border'
import { mapGetters } from 'vuex'
import urls from '@/utils/baseUrl'
import {buildMainSiteUrl} from '@/utils/navigate-nav-item'
export default {
  name: "SubnavPanel",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cleanupLighterBorder: null,
      cleanupScrollTriggers: [],
      linkUrl: urls.linkUrl,
    }
  },
  computed: {
        ...mapGetters([
            'chainConfig',
            'look',
            'currency',
            'languageName',
            'token',
            'userInfo',
            'levelConfig',
            'styleType',
            'language',
            'isDirection',
            'walletAddress',
            'walletChainId',
        ]),
    },
  mounted() {
    // 为卡片添加渐变边框
    this.cleanupLighterBorder = useLighterBorder(
        this,
        this.$refs.rootDom);
  },
  methods: {
    handleClick(item) {
      this.$store.dispatch('setGridType', item.tradeGroud? 'grid': item.tradeStock ? 'stock' : 'trade')
      if (item.type == 3) {
        this.$router.push(item.path);
        return;
      } 
      if (item.type == 2) {
        window.open(item.path, '_blank');
        return;
      }
      if (item.type == 1) {
        window.location.href = buildMainSiteUrl(this.linkUrl, item.path, this.language)
        return;
      }
    },
  },
  beforeDestroy() {
    if (this.cleanupLighterBorder) {
      this.cleanupLighterBorder();
    }
    this.cleanupScrollTriggers.forEach(cleanupFn => cleanupFn());
  },
};
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/_mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .subnav-panel {
    border-color: rgba(0, 0, 0, 0.1);
    background-color: #fff;
    box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);

    .nav-item {
      &:hover {
        background: #f6f6f6;

        .item-title {
          color: color(var(--theme-color));
        }
      }

      .item-title {
        color: rgba(var(--font-color), 0.8);
      }
    }
  }
}

.subnav-panel {
  --border-width: 1px;
  min-width: 222px;
  padding: 14px;
  transition: var(--transition-theme-color);
  border: var(--border-width) solid rgba(#fff, 0.1);
  border-radius: 8px;
  background: #202020;
  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.3);
  .nav-list {
    display: grid;

    gap: 16px;
  }

  .nav-item {
    font-size: 14px;

    padding: 10px 12px;

    transition: var(--transition-theme-color);

    border-radius: 6px;

    &:hover {
      color: color(var(--theme-color));
      background: #282828;

      .item-icon,
      .item-title,
      .item-subtitle {
        color: inherit;
      }
    }

    .item-inner {
      white-space: nowrap;

      gap: 8px;
    }

    .item-icon {
      font-size: em(18px, 14px);

      transition: var(--transition-theme-color);
      transform: translateY(0.05em);

      color: color(var(--font-color));
    }

    .item-title {
      font-weight: 500;
      // line-height: 160%; /* 22.4px */
      transition: var(--transition-theme-color);

      color: color(var(--font-color));
    }

    .item-subtitle {
      font-size: em(12px, 14px);
      font-weight: 400;
      // line-height: 160%; /* 19.2px */
      max-width: 350px;
      white-space: normal;
      transition: var(--transition-theme-color);

      color: color(var(--font-color), 0.6);
    }
  }
}

@include media-breakpoint-down(xl) {
  .subnav-panel {
    .assets-nav {
      .nav-item {
        font-size: 13px;
      }
    }
  }
}
</style>
